<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <div style="width: 80%; margin: auto; line-height: 26px; color: red">
        本租赁房屋系按间或按栋对外招租，不按权证面积计算。该房屋的建筑面积可能经测量机构测量存在差异，但不影响本次招租租金的价格。
      </div>

      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="是否存在以上情况"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          extra="提示：存在同一本产证分割招租的即存在该情形。"
          prop="hasExistAbove"
        >
          <div>
            <a-radio-group v-model="form.hasExistAbove" :disabled="!isEditable">
              <a-radio style="margin: 4px 0px" :value="1">是</a-radio>
              <a-radio style="margin: 4px 0px" :value="0">否</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24">
      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="抵押情况"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="mortgage"
        >
          <div>
            <a-radio-group v-model="form.mortgage" :disabled="!isEditable">
              <a-radio style="margin: 4px 0px" :value="1">存在</a-radio>
              <a-radio style="margin: 4px 0px" :value="0">不存在</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24">
      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="房屋状态"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="rentalStatus"
        >
          <a-select v-model="form.rentalStatus" placeholder="请选择" disabled>
            <a-select-option value="1"
              >本标的房屋租赁合同已到期，房屋尚在使用中，若招租后发生移交纠纷，由出租方负责解决</a-select-option
            >
            <a-select-option value="2"
              >本标的房屋尚在租赁合同期内，到期后由出租方负责落实资产交付相关事项</a-select-option
            >
            <a-select-option value="3"
              >本标的房屋物业状态为空置</a-select-option
            >
            <a-select-option value="99">其他</a-select-option>
          </a-select>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24" v-if="form.rentalStatus == 2" >
      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="租赁期限届满时间"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="leaseTermExpireTime"
        >
          <a-input
            disabled
            v-model="form.leaseTermExpireTime"
            placeholder="请输入租赁期限届满时间"
          />
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24" v-if="form.rentalStatus == 99">
      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="房屋状态其他说明"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="rentalStatusOtherDesc"
        >
          <a-input
            disabled
            v-model="form.rentalStatusOtherDesc"
            placeholder="请输入房屋状态其他说明"
          />
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24">
      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="其他招租条件"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="otherRequirement"
        >
          <div>
            <a-textarea
              placeholder="请输入其他招租条件"
              v-model="form.otherRequirement"
              :rows="1"
              :disabled="!isEditable"
            />
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24">
      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="是否存在优先承租权人"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="hasPriorityLease"
        >
          <div>
            <a-radio-group v-model="form.hasPriorityLease" :disabled="!isEditable">
              <a-radio style="margin: 4px 0px" :value="1">是</a-radio>
              <a-radio style="margin: 4px 0px" :value="0">否</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24" v-if="form.hasPriorityLease == 1 && form.hasRentFreePeriod == 1">
      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="优先承租权人续租是否享有免租期"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="isRfpEtLr"
        >
          <a-radio-group v-model="form.isRfpEtLr" :disabled="!isEditable">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </div>
    </a-col>

    <a-col :span="24" v-if="form.hasPriorityLease == 1">
      <div style="width: 90%; margin: auto; line-height: 26px">
        <a-form-model-item
          label="是否代办登记"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          prop="agencyRegistration"
        >
          <template v-slot:extra v-if="form.agencyRegistration == 1">
            <span style="color: red">
              原租户满足公告中招租条件和资格条件的要求，无需再递交承租登记相关材料。
            </span>
          </template>
          <div>
            <a-radio-group v-model="form.agencyRegistration" :disabled="!isEditable">
              <a-radio style="margin: 4px 0px" :value="1">是</a-radio>
              <a-radio style="margin: 4px 0px" :value="0">否</a-radio>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </div>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>

<style>
</style>